import React from 'react';
import InsertInfos from 'containers/LoginRecoveryPage/InsertInfosPage';
import SendLoginPage from 'containers/LoginRecoveryPage/SendLoginPage';
import {
  INSERT_INFOS,
  SEND_LOGIN_EMAIL,
} from 'containers/LoginRecoveryPage/constants';
import { CurrentRecoveryStepPropsType } from 'containers/LoginRecoveryPage/types';

const CurrentLoginRecoveryStep = ({
  stepName,
  onSubmitStep,
  isLoading,
}: CurrentRecoveryStepPropsType) => {
  switch (stepName) {
    case INSERT_INFOS:
      return <InsertInfos onSubmitStep={onSubmitStep} isLoading={isLoading} />;
    case SEND_LOGIN_EMAIL:
      return <SendLoginPage onSubmitStep={onSubmitStep} />;

    default:
      return <InsertInfos onSubmitStep={onSubmitStep} isLoading={isLoading} />;
  }
};

export default CurrentLoginRecoveryStep;
